export const WrapItem = {}

export default WrapItem
